const GH_SEARCH_URL = 'https://github.com/search?q=';

export default function toGitHubSearchUrl(query: string):string {
  return GH_SEARCH_URL + query.replaceAll(':', '%3A').split(" ").join("+");
}
